import {Params} from '@angular/router';

// import {PropsMapping} from '@shared/interfaces';
import {Model} from './model';
import {TeamModel} from './team.model';

// const propsMapping: PropsMapping = {
const propsMapping: Params = {
  id: 'subscriptionId',
  eventId: 'eventId',
  teamId: 'teamId',
  status: 'status',
  paymentStatus: 'paymentStatus',
  attendanceStatus: 'attendanceStatus',
  tournamentStatus: 'tournamentStatus',
  amountPaid: 'amountPaid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',

  team: 'team',
};

export class SubscriptionModel extends Model {
  categoryId!: number;
  eventId!: number;
  teamId!: number;
  status!: string;
  paymentStatus!: string;
  attendanceStatus!: string;
  tournamentStatus!: string;
  amountPaid!: string;
  createdAt!: Date;
  updatedAt!: Date;

  team?: TeamModel;

  static getInstance(data: Params): SubscriptionModel {
    const model = new SubscriptionModel();
    for (const prop in propsMapping) {
      if (
        data[propsMapping[prop]] === undefined ||
        data[propsMapping[prop]] === null
      ) {
        continue;
      }

      if (['createdAt', 'updatedAt'].includes(prop)) {
        (model as Params)[prop] = new Date(data[propsMapping[prop]]);
      } else if (prop === 'team') {
        (model as Params)[prop] = TeamModel.getInstance(data[propsMapping[prop]]);
      } else {
        (model as Params)[prop] = data[propsMapping[prop]];
      }
    }

    return model;
  }

  // static search(
  //   apiService: ApiService,
  //   eventId: number,
  //   urlParams?: HttpParams
  // ): Observable<ListState<SubscriptionModel>> {
  //   return apiService
  //     .get(`events/${eventId}/subscriptions`, urlParams)
  //     .pipe(
  //       map((data: Params): ListState<SubscriptionModel> => {
  //         const list: SubscriptionModel[] = data['data'].map((item: Params): SubscriptionModel =>
  //           SubscriptionModel.getInstance(item)
  //         );
  //
  //         // const paginator: Paginator = {
  //         //   total: data.total,
  //         //   perPage: data.perPage,
  //         //   currentPage: data.currentPage,
  //         //   lastPage: data.lastPage,
  //         //   // from: data.from,
  //         //   // to: data.to
  //         // };
  //
  //         // return {list, paginator};
  //         return {list};
  //       })
  //     );
  // }
}
